var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiveInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 19.7,
    height: 19.7,
    viewBox: "0 0 19.7 19.7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H13.7C17.0137 0 19.7 2.68629 19.7 6V13.7C19.7 17.0137 17.0137 19.7 13.7 19.7H6C2.68629 19.7 0 17.0137 0 13.7V6C0 2.68629 2.68629 0 6 0ZM18.2 6C18.1945 3.517 16.183 1.5055 13.7 1.5H6C3.517 1.5055 1.5055 3.517 1.5 6V13.7C1.5055 16.183 3.517 18.1945 6 18.2H13.7C16.183 18.1945 18.1945 16.183 18.2 13.7V6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55 9.85C5.5555 7.47746 7.47746 5.5555 9.85 5.55C12.2225 5.5555 14.1445 7.47746 14.15 9.85C14.15 12.2248 12.2248 14.15 9.85 14.15C7.47518 14.15 5.55 12.2248 5.55 9.85ZM12.65 9.85C12.65 8.3036 11.3964 7.05 9.85 7.05C8.30588 7.05549 7.05549 8.30588 7.05 9.85C7.05 11.3964 8.3036 12.65 9.85 12.65C11.3964 12.65 12.65 11.3964 12.65 9.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.51 4.505C13.51 3.90577 13.9958 3.42 14.595 3.42C15.1942 3.42 15.68 3.90577 15.68 4.505C15.68 5.10423 15.1942 5.59 14.595 5.59C13.9958 5.59 13.51 5.10423 13.51 4.505Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiveInstagram);
export default __webpack_public_path__ + "static/media/hive-instagram.13babe0502bf0dd399d49373522e0b2e.svg";
export { ForwardRef as ReactComponent };